import IconButton from "@common/components/IconButton";
import { ago } from "../library/dashboard";
import { errorText, useAdminLambdas } from "../library/queries";

function When({ iso, never }: { iso: string | null; never: string }) {
  if (!iso) return <span className="muted">{never}</span>;
  return (
    <time dateTime={iso} title={new Date(iso).toLocaleString()}>
      {ago(iso)} <span className="muted small">{new Date(iso).toLocaleDateString()}</span>
    </time>
  );
}

/** CloudBoy's Lambda functions: when each was last uploaded and last ran (GET /admin/lambdas). */
export default function AdminLambdas() {
  const lambdas = useAdminLambdas();
  const rows = lambdas.data ?? [];
  return (
    <section className="panel">
      <div className="section-head">
        <h2>Lambdas</h2>
        <IconButton icon="refresh" label="Refresh" onClick={() => void lambdas.refetch()} disabled={lambdas.isFetching} />
      </div>
      {lambdas.error ? (
        <p className="notice error">{errorText(lambdas.error, "Could not read the Lambda functions.")}</p>
      ) : lambdas.isLoading ? (
        <p className="muted small">Loading…</p>
      ) : rows.length === 0 ? (
        <p className="muted small">No functions configured.</p>
      ) : (
        <>
          <p className="muted small">
            Last upload is Lambda's last-modified time, which a configuration change also moves. Last run is the newest
            event in the function's log group.
          </p>
          <div className="visitor-table">
            <table>
              <thead>
                <tr>
                  <th>Function</th>
                  <th>Runtime</th>
                  <th>Last upload</th>
                  <th>Last run</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((lambda) => (
                  <tr key={lambda.name}>
                    <td className="mono">{lambda.name}</td>
                    <td>{lambda.runtime ?? "Container image"}</td>
                    <td>
                      <When iso={lambda.lastModified} never="—" />
                    </td>
                    <td>
                      <When iso={lambda.lastInvokedAt} never="No logs" />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </section>
  );
}
